// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"CompanyAdministratorUsersTable_deleteButton__39y-3"};